import benefitMerchandising from "img/partners/benefit-merchandising.webp";
import benefitOwnership from "img/partners/benefit-ownership.webp";
import benefitShopfronts from "img/partners/benefit-shopfronts.webp";
import React from "react";
import { Heading } from "web/react/emo/heading/heading";
import { Text } from "web/react/emo/text/text";
import { VStack } from "web/react/emo/v-stack/v-stack";
import { useSectionImpression } from "web/react/pages/partners/use-section-impression";
import { gettext, gettextNoop } from "web/script/modules/django-i18n";
import * as styles from "./partners-benefits.css";

interface CardConfig {
    number: string;
    titleKey: string;
    bodyKey: string;
    image: string;
}

const CARDS: CardConfig[] = [
    {
        number: "01",
        titleKey: gettextNoop("partners.benefits.card_1_title"),
        bodyKey: gettextNoop("partners.benefits.card_1_body"),
        image: benefitShopfronts,
    },
    {
        number: "02",
        titleKey: gettextNoop("partners.benefits.card_2_title"),
        bodyKey: gettextNoop("partners.benefits.card_2_body"),
        image: benefitMerchandising,
    },
    {
        number: "03",
        titleKey: gettextNoop("partners.benefits.card_3_title"),
        bodyKey: gettextNoop("partners.benefits.card_3_body"),
        image: benefitOwnership,
    },
];

export default function PartnersBenefits(): JSX.Element {
    const sectionRef = useSectionImpression("benefits", 3);

    return (
        <section ref={sectionRef} id="benefits" className={styles.section}>
            <div className={styles.container}>
                <div className={styles.header}>
                    <VStack spacing="xs">
                        <Text textStyle="caption-s" color="secondary" className={styles.eyebrow}>
                            {gettext("partners.nav.benefits")}
                        </Text>
                        <Heading textStyle="hero-l" as="h2">
                            {gettext("partners.benefits.headline")}
                        </Heading>
                    </VStack>
                </div>

                <div className={styles.grid}>
                    {CARDS.map(({ number, titleKey, bodyKey, image }, index) => (
                        <article
                            key={number}
                            className={index === 2 ? styles.cardThird : styles.card}
                        >
                            <img src={image} alt="" className={styles.cardImage} loading="lazy" />
                            <div className={styles.cardText}>
                                <Text textStyle="caption-s" color="secondary">
                                    {number}
                                </Text>
                                <VStack spacing="md">
                                    <Heading textStyle="hero-xs" as="h3">
                                        {gettext(titleKey)}
                                    </Heading>
                                    <Text textStyle="body" color="secondary" as="p">
                                        {gettext(bodyKey)}
                                    </Text>
                                </VStack>
                            </div>
                        </article>
                    ))}
                </div>
            </div>
        </section>
    );
}
